<div class="row">
  <div class="card shadow-none rounded">
    <div class="card-body">
      <div class="col-12 col-md-12 col-xxl-12 col-xl-12">
        <div class="row">
          <div class="col-12 col-xxl-10 col-xl-10 col-md-10 col-lg-10 col-sm-10">
            <h4 class="fw-bold">Accounting Basis - {{commonService.headerName}}</h4>
          </div>
          <div class="col-12 col-xxl-2 col-xl-2 col-md-2 col-lg-2 col-sm-2 text-start text-sm-end p-sm-0 pt-2">
            <button type="button" class="btn btn-outline-themecolorlight" style="padding: 7px;font-weight: 600; font-size: 14px;" tabindex="-1" (click)="totalback()">Close Accounts</button>
          </div>
        </div>
      </div>
      <hr />

      <div class="col-12 col-md-12 col-xxl-12 col-xl-12 col-lg-12  col-sm-12">
        <div class="row">
          <form [formGroup]="Accountingbasisform">
            <!--<div class="col-12 col-xxl-11 col-xl-12 col-md-12 col-lg-12 col-sm-12">-->
              <!--<h5 class="fw-bolder font-size-16 mb-3">Accounting basis <span class="text-danger">*</span></h5>-->
              <!--<div class="mb-3">
                <textarea class="form-control allowSpecialChars" [appTooltip]="showBubbledata" appNumberdirective rows="6" formControlName="AccountingBasisAdditionalInformation" style="font-size:15px"></textarea>
              </div>
            </div>-->
            <div class="row mb-1">
              <div class="col-12 col-xxl-12 col-xl-12 col-md-12 col-lg-12 col-sm-12">
                <div class="d-flex row justify-content-between align-items-center my-1">
                  <h5 class="fw-bolder font-size-16 col-xxl-10 mb-1">Accounting basis <span class="text-danger">*</span></h5>
                  <div class="col-12 col-xxl-2 col-xl-12 col-md-12 col-lg-12 col-sm-12 text-right float-end">
                    <button class="btn btndef p-1 px-2 me-0 text-center float-end" type="button" [disabled]="disableDefaultButton" (click)="getDefaultStatements()">Default Statement</button>
                  </div>
                </div>
                
                <div>
                  <textarea class="form-control allowSpecialChars"  appNumberdirective rows="6" maxlength="4000" formControlName="AccountingBasisAdditionalInformation" style="font-size:15px"></textarea>
                </div>
              </div>
              
            </div>
          </form>
         

          <!--<div class="col-12 col-xxl-10 col-xl-12 col-md-12 col-lg-12 col-sm-12 mb-3">
            <h5 class="fw-bolder font-size-16 mb-3">Approval Statement <span class="text-danger">*</span></h5>
            <div class="mb-3">
              <textarea class="form-control" rows="6" style="font-size:20px"></textarea>
            </div>
          </div>-->


          <div class="col-12 col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 text-end mt-4">
            <button type="button" class="btn btn-outline-back p-1 ps-3 pe-3 me-2"(click)="back()">Back</button>
            <button type="button" class="btn themedefault p-1 ps-3 pe-3 ms-1 me-0" (click)="save()">Next</button>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>
